import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import React from 'react';
import { NavLink } from 'react-router-dom';
import TextLink from 'components/TextLink';
import DetailsDropdown from 'components/ContentInfo/DropdownInfo';
import { jsx as _jsx } from "react/jsx-runtime";
export var PlaylistDropdown = function PlaylistDropdown(_ref) {
  var playlists = _ref.playlists,
    children = _ref.children;
  return /*#__PURE__*/_jsx(DetailsDropdown, {
    titleKey: "parent_playlist_item_panel_popup_title_colon",
    listItems: playlists.map(function (playlist) {
      return /*#__PURE__*/_jsx(TextLink, {
        as: NavLink,
        to: "/playlists/".concat(playlist.id),
        bold: true,
        children: playlist.name
      }, playlist.id);
    }),
    listLayout: "stack",
    children: children
  });
};
export default PlaylistDropdown;